import React, { useEffect, useState } from "react";
import { useTranslation } from 'react-i18next';
import { ProfileDetails, updateBookingReminderSetting } from "../services/webuser.service";

const UserSetting = () => {
  const { t } = useTranslation();
  const [bookingReminderEnabled, setBookingReminderEnabled] = useState(true);
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    ProfileDetails()
      .then((response) => {
        if (response?.success && response?.data) {
          setBookingReminderEnabled(Boolean(response.data.booking_reminder_enabled));
        }
      })
      .catch(() => {
        setBookingReminderEnabled(true);
      });
  }, []);

  const handleToggle = async (event) => {
    const isEnabled = event.target.checked;
    setBookingReminderEnabled(isEnabled);
    setIsLoading(true);
    try {
      const response = await updateBookingReminderSetting({
        booking_reminder_enabled: isEnabled,
      });
      if (!response?.success) {
        setBookingReminderEnabled(!isEnabled);
      }
    } catch (error) {
      setBookingReminderEnabled(!isEnabled);
    } finally {
      setIsLoading(false);
    }
  };

  return <div className="dash-main-R">
        <div className="row">
          <div className="col-md-9 m-auto">
            <h3 className="dash-title mt-4">{t("Setting")}</h3>
            <div className="dash-box-shadow space-b">
              <div className="toggle-box d-flex align-items-center justify-content-between mb-0">
                <div>
                  <label className="form-label mb-1">{t("Booking Reminder")}</label>
                  <p className="mb-0 text-muted">
                    {t("Enable or disable booking reminder emails")}
                  </p>
                </div>
                <label className="switch booking-reminder-switch">
                  <input
                    type="checkbox"
                    checked={bookingReminderEnabled}
                    onChange={handleToggle}
                    disabled={isLoading}
                  />
                  <span
                    className="slider round"
                    style={bookingReminderEnabled ? { backgroundColor: "#6c3" } : {}}
                  />
                </label>
              </div>
            </div>
          </div>
        </div>
      </div>;
};

export default UserSetting;
